
import { Injectable } from "@angular/core";
import { ServiceProvider } from "./service.provider";
import { SchedulerBaseService } from "./scheduler.base.service";
import { bookingSavePayload, RescheduleBooking } from "app/models/bookings.model";

@Injectable({
  providedIn: "root",
})
export class BookingService extends SchedulerBaseService {

  constructor(public provider: ServiceProvider) {
    super("api/scheduled-sessions", provider);
    
  }

  public getById(id){
    return this.getById(id)
  }

  public saveBooking(data:bookingSavePayload) {
   return this.save(data)
  }

  public reschedule(data:RescheduleBooking,bookingId:string) {
   return this.update(data,`/${bookingId}`)
  }

  public deletePage(data) {
   return this.deleteRecord(`/${data}`)
  }
  
}